export type LanguageCode = 'nl' | 'en';

type Language = {
	code: LanguageCode;
	file: `${LanguageCode}.ts`;
};
const languages: Language[] = [
	{
		code: 'nl',
		file: 'nl.ts',
	},
	{
		code: 'en',
		file: 'en.ts',
	},
];

export default languages;
